import { Redirect, useParams } from 'react-router';
import { DataSourceBreadCrumbs } from 'components';
import DimensionHelmet from 'components/DimensionHelmet';
import { IndustriesPlaceholderMessage } from 'components/Placeholders';
import { useCountryParam } from 'utils/hooks';
import useCurrentCountry from 'utils/hooks/useCurrentCountry';
import { useEffect } from 'react';
import { useUserIndustriesOverviewV2 } from 'utils/hooks/useUserIndustries';

import { DATA_COVERAGE, DATA_SOURCES, isCovered } from '@/config/constants';
import DataSourceQueryError from 'components/DataSourceQueryError';
import NoDataSourceMarketCoverage from 'components/NoDataSourceMarketCoverage';
import PageBar from 'components/PageBar';
import { PagePadding } from 'components/PagePadding';
import { mixpanelTrack } from 'utils/app';

const DATA_SOURCE_MAP = {
    google: DATA_SOURCES.GOOGLE,
    tiktok: DATA_SOURCES.TIKTOK,
    instagram: DATA_SOURCES.INSTAGRAM,
};

function CategoryOne(props) {
    const country = useCurrentCountry();
    const { industryName, dataSource: dataSourceParam } = useParams();
    const { mutateToWithCountryParam } = useCountryParam();
    const popularityIndustriesQuery = useUserIndustriesOverviewV2();

    const dataSource =
        dataSourceParam && DATA_SOURCE_MAP[dataSourceParam]
            ? DATA_SOURCE_MAP[dataSourceParam]
            : DATA_SOURCES.POPULARITY;

    useEffect(() => {
        if (!industryName) return;
        mixpanelTrack('Cat1', { industry: industryName });
    }, [industryName]);

    return (
        <PagePadding>
            <PageBar />
            <DimensionHelmet type="category" name={industryName} />
            <div css="position: relative; z-index: 1; margin-bottom: 18px;">
                <DataSourceBreadCrumbs
                    dataSource={dataSource}
                    cat1={industryName}
                    geo={country?.text_id}
                    viewingIndustries
                />
            </div>
            {dataSource === DATA_SOURCES.POPULARITY &&
            popularityIndustriesQuery.isError ? (
                <DataSourceQueryError
                    dataSource={dataSource}
                    country={country}
                    industryName={industryName}
                />
            ) : country &&
              !isCovered({
                  geo: country?.text_id,
                  dataSource,
                  cat1: industryName,
              }) ? (
                <NoDataSourceMarketCoverage dataSource={dataSource} />
            ) : (
                <IndustriesPlaceholderMessage />
            )}
        </PagePadding>
    );
}

export default CategoryOne;
